import * as React from 'react';
import { UserContext } from '../context/userContext';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';

import Box from '@mui/material/Box';
import {
  Autocomplete,
  Card,
  CardContent,
  CardHeader,
  Stack,
  TextField,
} from '@mui/material';
import { Helmet } from 'react-helmet';
import { libraryService } from '../api';
import { LibraryListType } from '../types';

const columns: GridColDef[] = [
  { field: 'uc_doc_title_per_owner', headerName: 'Title', width: 600 },
  // { field: 'firstName', headerName: 'Author', width: 50 },
  // { field: 'lastName', headerName: 'Pages', width: 50 },
  // { field: 'lastName', headerName: 'Publication date', width: 50 },
];

export const Library: React.FC = () => {
  const { loggedIn } = React.useContext(UserContext);
  const { libraryTagList = [], getLibraries, libraryList } = libraryService();
  const paginationModel = { page: 0, pageSize: 20 };

  const rows = libraryList;

  const handleSelectBundle = (event: any, bundle: LibraryListType | null) => {
    if (bundle?.slug) {
      getLibraries({ slug: bundle?.slug });
    }
    // setSelectedBundles(bundles);
  };

  return loggedIn ? (
    <Box component="main" p={3}>
      <Helmet>
        <title>Library</title>
      </Helmet>
      <Card sx={{ minWidth: 400 }}>
        <CardHeader
          title="Library"
          // subheader={

          // }
        />

        <CardContent>
          <Stack spacing={1}>
            <Autocomplete
              id="bundle-tag-selector"
              sx={{ width: 300 }}
              autoHighlight
              options={libraryTagList}
              filterSelectedOptions
              onChange={handleSelectBundle}
              getOptionLabel={({ name }) => name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Library"
                  placeholder="Please select library."
                />
              )}
            />
            {/* ISSUE witdth width https://github.com/mui/mui-x/issues/11295 */}
            <DataGrid
              rows={rows}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
              columns={columns}
              initialState={{ pagination: { paginationModel } }}
            />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  ) : null;
};
